import { useSignOut } from '@/hooks/useSignOut'
import { useDevModeStore } from '@/stores/useDevModeStore'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/logout')({
  component: RouteComponent,
})

function RouteComponent() {
  const signOut = useSignOut()
  const { setDevMode } = useDevModeStore()

  useEffect(() => {
    void signOut()
    setDevMode(false)
  }, [signOut, setDevMode])

  return <div>Logging out...</div>
}
